import { t } from '@/i18n';
import { z } from 'zod';

export const graphTypeEnum = z.enum([
  'stackedVerticalBar',
  'pieChart',
  'treeMap',
]);

export const GraphTypeLabelModifier = {
  stackedVerticalBar: t('stacked-column-chart'),
  pieChart: t('pie-chart'),
  treeMap: t('tree-map-chart'),
} as const satisfies Record<z.infer<typeof graphTypeEnum>, string>;

const ReportProjectAnalysisModel = z.object({
  fiscalYear: z.number().int(),
  total: z.number(),
  analysisAxis: z.object({
    parent: z.string().nullish(),
    /** 分析の軸がnullの場合undefinedになる */
    id: z.string().uuid().nullish(),
    /** 分析の軸がnullの場合string、それ以外はnumberになる */
    name: z.union([z.string(), z.number()]),
    /** 分析の軸がnullの場合string、それ以外はnumberになる*/
    sortingCode: z.union([z.string(), z.number()]).nullish(),
  }),
});

export const ProjectAnalysisModels = ReportProjectAnalysisModel.array();
